/*! @pentacode/ui v0.1.0 */
import { a as e, i as t, n, t as r } from "./styledElement-DUAqv8gi.js";
import "./file-card-DXmPuWhR.js";
import "./icon-DW8BBY5W.js";
import "./textarea-Cyvwmldp.js";
import "./assistant-avatar-Cz6-uDf0.js";
import "./assistant-chat-rating-CmC8ZDeF.js";
import { t as i } from "./assistant-chat-window-Cszxe5BB.js";
import { activeIcon as a } from "./elements/icon/active-icon.js";
import "./assistant-specialists-bar-gtBOAEEG.js";
import "./assistant-spinner-CfmqXlk1.js";
import "./assistant-suggestions-4XupKMF3.js";
import { t as o } from "./reduced-motion.css-tEHc8kYn.js";
import { t as s } from "./css-build-DcREbovZ.js";
import { t as c } from "./decorateMetadata-BXz2gmG4.js";
import { t as l } from "./decorate-C_HUHFGG.js";
import { LitElement as u, html as d, nothing as f } from "lit";
import { customElement as p, property as m, query as h, state as g } from "lit/decorators.js";
import { repeat as _ } from "lit/directives/repeat.js";
// src/utils/adopt-node.ts
function v(e, t = []) {
	if (e.localName.includes("-") && t.push(e), e.shadowRoot) for (let n of e.shadowRoot.querySelectorAll("*")) v(n, t);
	for (let n of e.querySelectorAll("*")) v(n, t);
	return t;
}
function y(e) {
	return v(e).map((e) => ({
		el: e,
		proto: Object.getPrototypeOf(e)
	}));
}
function b(r, i) {
	for (let { el: a } of i) {
		let i = a.shadowRoot;
		if (!i) continue;
		let o = "styles" in a ? a.styles : void 0;
		i.adoptedStyleSheets = [t(n(), r), ...e(o, r)];
	}
}
function x(e, t) {
	let n = y(t);
	e.adoptNode(t);
	for (let { el: e, proto: t } of n) Object.getPrototypeOf(e) !== t && Object.setPrototypeOf(e, t);
	return n;
}
function S(e, t, n, r) {
	let i = x(e, t);
	n.insertBefore(t, r ?? null), b(e, i);
}
// src/utils/pip.ts
async function C({ width: e = 420, height: t = 550, left: n, top: r, title: i } = {}) {
	let a = window.documentPictureInPicture, o = null;
	if (a) o = await a.requestWindow({
		width: e,
		height: t
	});
	else {
		let i = `popup,width=${e},height=${t}`;
		n != null && (i += `,left=${n}`), r != null && (i += `,top=${r}`), o = window.open("", "", i);
	}
	if (!o) return null;
	let s = o.document.createElement("base");
	s.href = document.baseURI, o.document.head.appendChild(s), i && (o.document.title = i), o.document.documentElement.style.overflow = "hidden";
	for (let e of document.head.querySelectorAll("link[rel=\"stylesheet\"], style")) o.document.head.appendChild(e.cloneNode(!0));
	return o;
}
function w(e, t) {
	S(t.document, e, t.document.body);
}
function T(e, t, n) {
	S(document, e, t, n);
}
// \0lit-plugin:css-sheet:./src/elements/assistant/assistant-chat/assistant-chat.css.js
var E = s(":host{--assistant-chat-bg-primary:#fff;--assistant-chat-bg-secondary:#fff;--assistant-chat-bg-gradient:radial-gradient(farthest-corner circle at 20% -100% in oklch, #eaf4cf 2%, #c3e7f5 70%);--assistant-chat-message-bg-user:#e3e3e3;--assistant-chat-message-text-user:#0a0a0a;--assistant-chat-accent-bg:#c3e7f5;--assistant-chat-mic-bg:#e1ff41;--assistant-chat-mic-color:#0a0a0a;--assistant-chat-text-primary:#0a0a0a;--assistant-chat-text-secondary:#282828;--_textbox-radius:var(--radius-round);display:contents}@supports (color:lab(0% 0 0)){:host{--assistant-chat-bg-gradient:radial-gradient(farthest-corner circle at 20% -100% in oklch, lab(94.7021% -7.96026 16.9497) 2%, #c3e7f5 70%)}}ptc-ui-assistant-chat-window-base::part(header){background:var(--assistant-chat-bg-gradient)}.avatar-container{width:100%;height:100%;position:relative}.suggestions-toggle{background:var(--assistant-chat-mic-bg);width:1.25rem;height:1.25rem;color:var(--assistant-chat-text-secondary);cursor:pointer;z-index:5;border:none;border-radius:50%;justify-content:center;align-items:center;font-size:.65rem;transition:transform .15s,background-color .15s,color .15s;display:flex;position:absolute;top:-.5rem;right:0;box-shadow:0 2px 6px #00000026}.suggestions-toggle:hover{background:var(--assistant-chat-mic-bg);color:var(--assistant-chat-mic-color);transform:scale(1.1)}.suggestions-toggle:active{transform:scale(1.3)translateY(-2px)}.suggestions-toggle[data-active]{background:var(--assistant-chat-mic-bg);color:var(--assistant-chat-mic-color)}:host([pip]) .suggestions-toggle{top:0}ptc-ui-assistant-chat-window-base::part(footer){background:var(--assistant-chat-bg-primary)}ptc-ui-assistant-chat-rating{border:1px solid var(--border-color,var(--shade-3));margin:.5rem 1rem}:host(:not([open])) ptc-ui-assistant-chat-rating{pointer-events:all;isolation:isolate;width:max-content}:host([open]){--assistant-avatar-size:var(--_assistant-chat-header-height,3.5rem)}:host([open]) ptc-ui-assistant-chat-rating{padding:.5rem 1rem;position:sticky;bottom:1rem}.mic-btn{box-sizing:content-box;border-radius:var(--radius-round);background:var(--assistant-chat-mic-bg);width:1.5em;height:1.5em;color:var(--assistant-chat-mic-color);cursor:pointer;transform-origin:0;z-index:3;border:none;justify-content:center;align-items:center;padding:.5rem 1rem;font-size:.9rem;transition:all .2s;display:flex;position:absolute;bottom:0;left:50%;transform:translate(-50%,50%)}.mic-btn:hover{transform:scale(1.05)translate(-50%,50%)}.mic-btn[disabled]{opacity:.5;cursor:not-allowed}:host([listening]) .mic-btn{background:var(--aqua-bg)}:host([open]) .mic-btn{border-radius:var(--radius-round);inset:initial;transform:initial;padding:7px;position:relative}:host([open]) .mic-btn:active{transform:scale(.7)translate(6.5px)}.spinner-container{justify-content:start;justify-self:start;align-items:center;margin:0 1rem;padding:.75rem 0;transition:transform .2s,opacity .2s;display:flex}.spinner-container[data-visible=false]{opacity:0;transform:scale(0)}.spinner-container[data-visible=true]{opacity:1;transform:scale(1)}.spinner-container[data-overlay=true]{justify-content:center;margin:0;padding:0}.spinner-container[data-overlay=true] ptc-ui-assistant-spinner{scale:4}:host(:not([open])) ptc-ui-assistant-spinner{transform:skew(-41deg,22deg)}ptc-ui-assistant-spinner{overflow:hidden}ptc-ui-assistant-specialists-bar{z-index:2;flex:0;height:0;position:sticky;top:0}ptc-ui-assistant-suggestions{scrollbar-width:thin;scrollbar-color:var(--neon) color-mix(in oklab, black 10%, var(--neon));pointer-events:all;place-self:center;width:100%;transition:all .2s;position:sticky;bottom:0;right:0}ptc-ui-assistant-suggestions[data-hidden]{pointer-events:none}ptc-ui-assistant-suggestions[data-showing=true]{margin-top:.5em}:host([open]) ptc-ui-assistant-suggestions{background:color-mix(in oklab, white 50%, var(--sky-blue));width:calc(100% - 2rem);height:0;margin-bottom:1rem}:host([open]) ptc-ui-assistant-suggestions[data-showing=true]{height:12rem}.messages-container{transform-origin:0 0;flex-direction:column;gap:1rem;height:auto;padding:1rem;display:flex;position:relative;overflow:visible}.limit-banner{border-radius:.5rem;align-items:flex-start;gap:.4rem;margin:-.5rem -.5rem .25rem;padding:.5rem .7rem;font-size:.8rem;line-height:1.4;display:flex}.limit-banner ptc-ui-icon{flex:none;margin-top:.15rem}.limit-banner[data-severity=warning]{background:color-mix(in srgb, var(--yellow,#f5a524) 18%, transparent);color:color-mix(in srgb, var(--yellow,#f5a524) 70%, black)}.limit-banner[data-severity=blocked]{background:color-mix(in srgb, var(--red,#e5484d) 18%, transparent);color:color-mix(in srgb, var(--red,#e5484d) 70%, black)}.message-with-avatar{align-items:flex-end;display:flex}.message-with-avatar .avatar-placeholder{flex-shrink:0;width:40px;height:40px}.message{border:none;border-radius:18px;max-width:80%;margin:0;padding:.75rem 1rem;font-size:.9rem;line-height:1.5;animation:.3s messageIn}.message-assistant{background:var(--assistant-chat-accent-bg);color:var(--assistant-chat-text-primary);border-bottom-left-radius:6px;align-self:flex-start}.message-user{background:var(--assistant-chat-message-bg-user);color:var(--assistant-chat-message-text-user);border-bottom-right-radius:6px;align-self:flex-end}.message-files{flex-direction:column;gap:.5rem;display:flex}.message-files[data-with-text]{margin-top:.5rem}.messages-container::-webkit-scrollbar{width:6px}.messages-container::-webkit-scrollbar-track{background:0 0}.messages-container::-webkit-scrollbar-thumb{background:#ffffff1a;border-radius:3px}.messages-container::-webkit-scrollbar-thumb:hover{background:#fff3}[slot=input]{grid-template-columns:auto min-content;display:grid}ptc-ui-textarea{--outline-color:var(--sky-blue);--outline-focus-color:var(--assistant-chat-accent-bg);--text-area-padding:.5em .75em;--_textbox-radius:1lh;grid-area:1/1/1/3;font-size:.9rem}ptc-ui-textarea::part(textarea){padding-right:1.8rem}.send-btn{z-index:2;cursor:pointer;aspect-ratio:1;border-radius:var(--radius-round);background:var(--sky-blue);border:none;grid-area:1/2/2/3;place-content:center;place-self:end;height:1.5rem;margin:6px;padding:0;font-size:.9rem;transition:transform .2s ease-in-out;display:grid}.send-btn:hover{transform:scale(1.1)}.send-btn:active{transform:scale(1.35)}.send-btn--stop{background:color-mix(in lab, var(--raspberry), transparent)}.attach-btn{z-index:2;cursor:pointer;aspect-ratio:1;border-radius:var(--radius-round);height:1.5rem;color:var(--assistant-chat-text-primary,inherit);opacity:.7;background:0 0;border:none;grid-area:1/1/2/2;place-content:center;place-self:end start;margin:6px;padding:0;font-size:.9rem;transition:opacity .2s ease-in-out;display:grid}.attach-btn:hover:not(:disabled){opacity:1}.attach-btn:disabled{cursor:default;opacity:.4}:host([files-enabled]) [slot=input] ptc-ui-textarea::part(textarea){padding-left:2rem}.rating-wrapper{z-index:2;align-self:center;position:sticky;bottom:1rem}@keyframes messageIn{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}"), D = class extends r(u) {
	constructor(...e) {
		super(...e), this.styles = [E, o], this.open = !1, this.label = "Yna Chat", this.avatarSrc = "", this.messages = [], this.conversationState = "uninitialized", this.root = null, this.showRating = !1, this.showSuggestions = !1, this.suggestions = [], this.recommendations = [], this.listening = !1, this.pip = !1, this.limitState = "none", this.limitMessage = "", this.specialists = [], this.metadata = {}, this.audioLevel = 0, this.hideMic = !1, this.layoutStyle = "", this.filesEnabled = !1, this.filesAccept = "", this._currentMessage = "", this._pendingMessage = null, this._pipWindow = null, this._pipPlaceholder = null, this._appliedLayoutProperties = [], this._handleStopClick = (e) => {
			e.stopPropagation(), this.dispatchEvent(new CustomEvent("stop-click", {
				bubbles: !0,
				composed: !0
			}));
		}, this._handleToggle = (e) => {
			this.open = e.detail.open, this.open || (this.showSuggestions = !1), this.dispatchEvent(new CustomEvent("toggle", {
				detail: { open: this.open },
				bubbles: !0,
				composed: !0
			}));
		}, this._handleClose = () => {
			this.open = !1, this.showSuggestions = !1, this.showRating = !1, this.dispatchEvent(new CustomEvent("close", {
				bubbles: !0,
				composed: !0
			}));
		}, this._pipPending = !1, this._handlePiP = () => {
			this._pipWindow ? this._moveBackFromPiP() : this._pipPending || this._moveToPiP();
		}, this._micPointerDown = !1, this._micHovered = !1, this._handleMicEnter = () => {
			this._micHovered = !0;
		}, this._handleMicLeave = (e) => {
			this._micHovered = !1, this._handleMicRelease(e);
		}, this._handleMicPress = (e) => {
			e.stopPropagation(), e.preventDefault(), this._micPointerDown = !0, this.dispatchEvent(new CustomEvent("mic-press", {
				bubbles: !0,
				composed: !0
			}));
		}, this._handleMicRelease = (e) => {
			this._micPointerDown && (this._micPointerDown = !1, e.stopPropagation(), this.dispatchEvent(new CustomEvent("mic-release", {
				bubbles: !0,
				composed: !0
			})));
		}, this._handleRatingSubmit = () => {
			this.showRating = !1;
		}, this._handleSuggestionClick = (e) => {
			this.showSuggestions = !1;
			let t = e.detail.prompt?.trim();
			t && (this.open ? this._isInitializing ? this._pendingMessage = t : this.dispatchEvent(new CustomEvent("text-submit", {
				detail: { message: t },
				bubbles: !0,
				composed: !0
			})) : (this._pendingMessage = t, this.dispatchEvent(new CustomEvent(i.OPEN, {
				bubbles: !0,
				composed: !0
			}))));
		}, this._handleExpandToggle = (e) => {
			e.detail.expanded && !this.open && (this.open = !0, this.dispatchEvent(new CustomEvent("toggle", {
				detail: { open: !0 },
				bubbles: !0,
				composed: !0
			})));
		}, this._handleTextInput = (e) => {
			this._currentMessage = e.target.value;
		}, this._handleTextKeydown = (e) => {
			this._isInputDisabled ? e.preventDefault() : e.key === "Enter" && !e.shiftKey && (e.preventDefault(), this._submitText());
		}, this._handleAttachClick = () => {
			this._isInputDisabled || this._fileInput?.click();
		}, this._handleFilesPicked = (e) => {
			let t = e.target, n = Array.from(t.files ?? []);
			t.value = "", n.length && (this.dispatchEvent(new CustomEvent("files-selected", {
				detail: { files: n },
				bubbles: !0,
				composed: !0
			})), this._windowBase?.scrollToBottom(!0));
		}, this._handleSuggestionsToggle = (e) => {
			e.stopPropagation(), this.showSuggestions = !this.showSuggestions, this.dispatchEvent(new CustomEvent("suggestions-toggle", {
				detail: { showSuggestions: this.showSuggestions },
				bubbles: !0,
				composed: !0
			}));
		};
	}
	dispatchEvent(e) {
		let t = super.dispatchEvent(e);
		return this._pipPlaceholder && this._pipPlaceholder.dispatchEvent(new CustomEvent(e.type, {
			detail: e.detail,
			bubbles: !0,
			composed: !0
		})), t;
	}
	get _isInitializing() {
		return this.conversationState === "initializing";
	}
	get _isBusy() {
		return this.conversationState === "thinking" || this.conversationState === "speaking";
	}
	get _isLocked() {
		return this.limitState === "blocked";
	}
	get _isInputDisabled() {
		return this._isInitializing || this._isLocked;
	}
	get _isSpinnerVisible() {
		return this.open && this.conversationState === "initializing" || this.conversationState === "thinking" || !this.open && this.conversationState === "speaking";
	}
	async _moveToPiP() {
		let e = this.parentNode;
		if (!e) return;
		this._pipPending = !0;
		let t = document.createElement("div");
		t.style.display = "none", e.insertBefore(t, this), this._pipPlaceholder = t;
		let n = this._windowBase?.getBoundingClientRect(), r = await C({
			width: Math.round(n?.width || 0) || 420,
			height: Math.round(n?.height || 0) || 550,
			left: n ? Math.round(n.left + window.screenX) : void 0,
			top: n ? Math.round(n.top + window.screenY) : void 0,
			title: this.label
		});
		this._pipPending = !1, r ? (this._pipWindow = r, this.open || (this.open = !0, this.dispatchEvent(new CustomEvent("toggle", {
			detail: { open: !0 },
			bubbles: !0,
			composed: !0
		}))), this.pip = !0, w(this, r), await this.updateComplete, this._spinner?._activate?.(), r.addEventListener("pagehide", () => {
			this._moveBackFromPiP();
		})) : (t.remove(), this._pipPlaceholder = null);
	}
	async _moveBackFromPiP() {
		this.pip = !1;
		let e = this._pipPlaceholder?.parentNode;
		(e instanceof Element || e instanceof DocumentFragment) && (T(this, e, this._pipPlaceholder), this._pipPlaceholder.remove()), this._pipPlaceholder = null, this._pipWindow &&= (this._pipWindow.close(), null), await this.updateComplete, this._spinner?._activate?.();
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._pipWindow && !this._pipPlaceholder && (this._pipWindow.close(), this._pipWindow = null);
	}
	_submitText() {
		if (this._isInputDisabled) return;
		let e = this._currentMessage.trim();
		e && (this.dispatchEvent(new CustomEvent("text-submit", {
			detail: { message: e },
			bubbles: !0,
			composed: !0
		})), this._currentMessage = "", this._textarea?.clear(), this.showSuggestions = !1, this._windowBase?.scrollToBottom(!0));
	}
	willUpdate(e) {
		super.willUpdate(e), this._isInputDisabled || this.hideMic ? this._micHovered = !1 : (e.has("conversationState") || e.has("limitState") || e.has("hideMic")) && (this._micHovered = this._micButton?.matches(":hover") ?? !1);
	}
	async updated(e) {
		if (super.updated(e), e.has("conversationState") && !this._isInitializing && this._pendingMessage) {
			let e = this._pendingMessage;
			this._pendingMessage = null, this.dispatchEvent(new CustomEvent("text-submit", {
				detail: { message: e },
				bubbles: !0,
				composed: !0
			}));
		}
		if (e.has("layoutStyle") && this._windowBase) {
			for (let e of this._appliedLayoutProperties) this._windowBase.style.removeProperty(e);
			if (this._appliedLayoutProperties = [], this.layoutStyle) for (let e of this.layoutStyle.split(";")) {
				let [t, n] = e.split(":").map((e) => e.trim());
				t && n && t.startsWith("--assistant-chat-") && (this._windowBase.style.setProperty(t, n), this._appliedLayoutProperties.push(t));
			}
		}
		let t = e.get("messages");
		if (t && t.length > 0 && this.messages.length === 0 && (this.showSuggestions = !0), (e.has("open") || e.has("messages") || e.has("conversationState")) && (await this._windowBase?.updateComplete, this.open)) {
			let t = e.has("open");
			this._windowBase?.scrollToBottom(t), this._rating?.matches(":focus-within") || !e.has("open") && this._isFocusOutside() || this._textarea?.focus();
		}
	}
	_isFocusOutside() {
		let e = this.ownerDocument.activeElement;
		for (; e?.shadowRoot?.activeElement;) e = e.shadowRoot.activeElement;
		return !!e && e !== this.ownerDocument.body && !this.matches(":focus-within");
	}
	_renderAvatar() {
		return d`
            <div class="avatar-container">
                <ptc-ui-assistant-avatar src="${this.avatarSrc}"></ptc-ui-assistant-avatar>
                <button
                    id="avatar-suggestions-toggle"
                    class="suggestions-toggle"
                    @click=${this._handleSuggestionsToggle}
                    aria-label="Toggle suggestions"
                    title="Vorschläge ${this.showSuggestions ? "ausblenden" : "anzeigen"}"
                    ?data-active=${this.showSuggestions}
                >
                    <ptc-ui-icon
                        name=${this.showSuggestions ? "icon.toggle.suggestions" : "icon.toggle.suggestions-hidden"}
                    ></ptc-ui-icon>
                </button>
            </div>
        `;
	}
	_renderMessages() {
		let e = this.messages.some((e) => e.role === "user"), t = this.messages.findIndex((e) => e.role === "assistant");
		return d`
            <div class="messages-container" slot="content">
                ${this.limitState !== "none" && this.limitMessage ? d`<div class="limit-banner" data-severity=${this.limitState} role="status">
                          ${this.limitState === "blocked" ? d`<ptc-ui-icon name="icon.status.error"></ptc-ui-icon>` : d`<ptc-ui-icon name="icon.status.warning"></ptc-ui-icon>`}
                          <span>${this.limitMessage}</span>
                      </div>` : f}
                ${_(this.messages, (e) => e.id, (n, r) => {
			let i = !e && r === t, a = n.files?.length ? d`<div class="message-files" ?data-with-text=${!!n.content}>
                                  ${n.files.map((e) => d`<ptc-ui-file-card
                                              .name=${e.name}
                                              .url=${e.url ?? ""}
                                              .status=${e.status}
                                              .detail=${e.detail ?? ""}
                                          ></ptc-ui-file-card>`)}
                              </div>` : f;
			return i ? d`
                                <div class="message-with-avatar">
                                    <div class="avatar-placeholder"></div>
                                    <div class="message message-${n.role}" part="message message-${n.role}">
                                        ${n.content}${a}
                                    </div>
                                </div>
                            ` : d`
                            <div class="message message-${n.role}" part="message message-${n.role}">
                                ${n.content}${a}
                            </div>
                        `;
		})}
                <slot name="spinner"></slot>
            </div>
        `;
	}
	render() {
		return d`
            <ptc-ui-assistant-chat-window-base
                .open="${this.open}"
                .label="${this.label}"
                .root="${this.root}"
                .pip="${this.pip}"
                .audioLevel=${this.audioLevel}
                .hideMic=${this.hideMic}
                .avatarInHeader=${this.messages.some((e) => e.role === "user") || this.limitState !== "none"}
                .bubblePopupActive=${!this.open && (this.specialists.length > 0 || this.showRating)}
                .suggestionsPopupActive=${!this.open && this.showSuggestions}
                @ptc-ui-chat-toggle="${this._handleToggle}"
                @ptc-ui-chat-close="${this._handleClose}"
                @ptc-ui-chat-pip="${this._handlePiP}"
                exportparts="avatar, mic, header, content, spinner"
            >
                <div slot="avatar">${this._renderAvatar()}</div>
                ${this.hideMic ? f : d`<button
                          slot="mic"
                          class="mic-btn"
                          ?disabled="${this._isInputDisabled}"
                          @pointerdown="${this._handleMicPress}"
                          @pointerup="${this._handleMicRelease}"
                          @pointerenter="${this._handleMicEnter}"
                          @pointerleave="${this._handleMicLeave}"
                          aria-label="${this.listening ? "Mikrofon ausschalten" : "Mikrofon einschalten"}"
                          title="${this.listening ? "Mikrofon ausschalten" : "Mikrofon einschalten"}"
                      >
                          <ptc-ui-icon
                              name=${a(this.listening ? "icon.toggle.microphone-active" : "icon.toggle.microphone", this._micHovered)}
                          ></ptc-ui-icon>
                      </button>`}
                ${this._renderMessages()}
                <div slot="input">
                    ${this.filesEnabled ? d`<button
                                  class="attach-btn"
                                  @click=${this._handleAttachClick}
                                  ?disabled=${this._isInputDisabled}
                                  aria-label="Datei anhängen"
                                  title="Datei anhängen"
                              >
                                  <ptc-ui-icon name="icon.action.attach"></ptc-ui-icon>
                              </button>
                              <input
                                  class="file-input"
                                  type="file"
                                  multiple
                                  hidden
                                  accept=${this.filesAccept || f}
                                  @change=${this._handleFilesPicked}
                              />` : f}
                    <ptc-ui-textarea
                        .autoGrow=${!0}
                        .maxRows=${5}
                        placeholder="Nachricht schreiben…"
                        @input=${this._handleTextInput}
                        @keydown=${this._handleTextKeydown}
                        aria-label="Nachrichteneingabe"
                        ?disabled=${this._isInputDisabled}
                    ></ptc-ui-textarea>
                    ${this._isBusy ? d`<button class="send-btn send-btn--stop" @click=${this._handleStopClick}>
                              <ptc-ui-icon name="icon.action.stop-generation"></ptc-ui-icon>
                          </button>` : d`<button
                              class="send-btn"
                              @click=${() => this._submitText()}
                              ?disabled=${this._isInputDisabled}
                          >
                              <ptc-ui-icon name="icon.action.send-chat"></ptc-ui-icon>
                          </button>`}
                </div>

                <ptc-ui-assistant-specialists-bar
                    slot="specialist-status"
                    .specialists=${this.specialists}
                    .metadata=${this.metadata}
                    .fallback=${this.fallback}
                ></ptc-ui-assistant-specialists-bar>
                <div
                    slot="spinner"
                    class="spinner-container"
                    part="spinner"
                    data-visible=${this._isSpinnerVisible}
                    data-overlay=${this.open && this.conversationState === "initializing"}
                >
                    <ptc-ui-assistant-spinner
                        ?paused=${!this._isSpinnerVisible}
                        thickness="${this.open ? 2 : 1}"
                        ?atomOrbit=${this.conversationState === "initializing"}
                    ></ptc-ui-assistant-spinner>
                </div>
                ${this.showRating ? d`
                          <ptc-ui-assistant-chat-rating
                              slot="rating"
                              @rating-submit=${this._handleRatingSubmit}
                          ></ptc-ui-assistant-chat-rating>
                      ` : f}
                ${this.open ? d`
                          <ptc-ui-assistant-suggestions
                              data-showing="${this.showSuggestions && !this._isInitializing}"
                              slot="suggestions"
                              .suggestions=${this.suggestions}
                              .recommendations=${this.recommendations}
                              expanded
                              @suggestion-click=${this._handleSuggestionClick}
                          ></ptc-ui-assistant-suggestions>
                      ` : d`
                          <ptc-ui-assistant-suggestions
                              slot="bubble-suggestions"
                              .suggestions=${this.suggestions}
                              .recommendations=${this.recommendations}
                              ?data-hidden=${!this.showSuggestions}
                              @expand-toggle=${this._handleExpandToggle}
                              @suggestion-click=${this._handleSuggestionClick}
                              @pointerdown=${(e) => e.stopPropagation()}
                          ></ptc-ui-assistant-suggestions>
                      `}
            </ptc-ui-assistant-chat-window-base>
        `;
	}
};
l([m({
	type: Boolean,
	reflect: !0
}), c("design:type", Object)], D.prototype, "open", void 0), l([m({ type: String }), c("design:type", Object)], D.prototype, "label", void 0), l([m({
	type: String,
	attribute: "avatar-src"
}), c("design:type", Object)], D.prototype, "avatarSrc", void 0), l([m({ type: Array }), c("design:type", Array)], D.prototype, "messages", void 0), l([m({
	type: String,
	attribute: "conversation-state",
	reflect: !0
}), c("design:type", Object)], D.prototype, "conversationState", void 0), l([m({
	type: Object,
	reflect: !1
}), c("design:type", Object)], D.prototype, "root", void 0), l([m({
	type: Boolean,
	attribute: "show-rating",
	reflect: !0
}), c("design:type", Object)], D.prototype, "showRating", void 0), l([m({
	type: Boolean,
	attribute: "show-suggestions",
	reflect: !0
}), c("design:type", Object)], D.prototype, "showSuggestions", void 0), l([m({ type: Array }), c("design:type", Array)], D.prototype, "suggestions", void 0), l([m({ type: Array }), c("design:type", Array)], D.prototype, "recommendations", void 0), l([m({
	type: Boolean,
	reflect: !0
}), c("design:type", Object)], D.prototype, "listening", void 0), l([m({
	type: Boolean,
	reflect: !0
}), c("design:type", Object)], D.prototype, "pip", void 0), l([m({
	type: String,
	attribute: "limit-state",
	reflect: !0
}), c("design:type", String)], D.prototype, "limitState", void 0), l([m({
	type: String,
	attribute: "limit-message"
}), c("design:type", Object)], D.prototype, "limitMessage", void 0), l([m({ type: Array }), c("design:type", Array)], D.prototype, "specialists", void 0), l([m({ type: Object }), c("design:type", typeof Record > "u" ? Object : Record)], D.prototype, "metadata", void 0), l([m({ type: Object }), c("design:type", Object)], D.prototype, "fallback", void 0), l([m({ type: Number }), c("design:type", Object)], D.prototype, "audioLevel", void 0), l([m({
	type: Boolean,
	reflect: !0,
	attribute: "hide-mic"
}), c("design:type", Object)], D.prototype, "hideMic", void 0), l([m({
	type: String,
	attribute: "layout-style"
}), c("design:type", Object)], D.prototype, "layoutStyle", void 0), l([m({
	type: Boolean,
	attribute: "files-enabled",
	reflect: !0
}), c("design:type", Object)], D.prototype, "filesEnabled", void 0), l([m({
	type: String,
	attribute: "files-accept"
}), c("design:type", Object)], D.prototype, "filesAccept", void 0), l([h("ptc-ui-assistant-chat-window-base"), c("design:type", Object)], D.prototype, "_windowBase", void 0), l([h("ptc-ui-textarea"), c("design:type", Object)], D.prototype, "_textarea", void 0), l([h("ptc-ui-assistant-spinner"), c("design:type", Object)], D.prototype, "_spinner", void 0), l([h(".file-input"), c("design:type", typeof HTMLInputElement > "u" ? Object : HTMLInputElement)], D.prototype, "_fileInput", void 0), l([h(".mic-btn"), c("design:type", typeof HTMLButtonElement > "u" ? Object : HTMLButtonElement)], D.prototype, "_micButton", void 0), l([h("ptc-ui-assistant-chat-rating"), c("design:type", typeof HTMLElement > "u" ? Object : HTMLElement)], D.prototype, "_rating", void 0), l([g(), c("design:type", Object)], D.prototype, "_micHovered", void 0), D = l([p("ptc-ui-assistant-chat")], D);
export { D as t };

//# sourceMappingURL=assistant-chat-BELZgewu.js.map